import { render } from "./department.vue?vue&type=template&id=6fc31c00&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"

import "./department.vue?vue&type=style&index=0&id=6fc31c00&scoped=true&lang=css"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc31c00"]])

export default __exports__